export const getMeasurementsThatNeedASpace = () => {
	const measurementsThatNeedASpace = [
		"tablespoon",
		"teaspoon",
		"handful",
		"cup",
	];
	return measurementsThatNeedASpace;
};
